import { useMultiLayerDrawerContext } from '../components/MultiLayerDrawerProvider/MultiLayerDrawerProvider';

export const useMultiLayerDrawerEnabled = () => {
    const { isEnabled } = useMultiLayerDrawerContext();
    return isEnabled;
};
